import * as React from "react";
import { forwardRef } from "react";
const SvgA11YmenuAreaSplineChart = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.59424 6.75796C2.59424 6.75796 4.67321 2.82589 7.67 5.41292C10.6668 7.99995 12.8169 4.20757 12.8169 4.20757M2.66674 10.2222C2.66674 10.2222 5.59652 6.04632 7.96376 8.81917C10.331 11.592 13.3334 7.5555 13.3334 7.5555L13.3334 12.4444H2.66676L2.66674 10.2222Z", stroke: "#2B2B35", strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgA11YmenuAreaSplineChart);
export { ForwardRef as ReactComponent };
